import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../core/services";
import { Channel, ChannelAddParticipantRequest, ChannelCreate, ChannelLeaveRequest, ChannelMessageMarkRead, ChannelRenameRequest } from "./channel.models";

@Injectable({
  providedIn: 'root'
})
export class ChannelApi {
    private readonly httpService = inject(HttpService);

    createChannel(payload: ChannelCreate) {
        return this.httpService.post("channel", payload, false);
    }

    getChannel(){
        return this.httpService.get("channels",true);
    }

    markMessagesRead(payload: ChannelMessageMarkRead) {
        return this.httpService.post("channel/mark_as_read", payload, true);
    }

    leaveChannel(payload: ChannelLeaveRequest) {
        return this.httpService.post("channel/leave", payload, false);
    }

    addParticipant(payload: ChannelAddParticipantRequest) {
        return this.httpService.post("channel/add-participant", payload, false);
    }

    renameChannel(payload: ChannelRenameRequest) {
        return this.httpService.post("channel/rename", payload, true);
    }
}
